import useValidation from "../useValidation";
import contentTypeValidation from "./contentTypeValidation";
import descriptionValidation from "./descriptionValidation";
import publicityValidation from "./publicityValidation";
import titleValidation from "./titleValidation";
import facultyDepartmentValidation from './facultyDepartmentValidation';
import scienceValidation from './scienceValidation';
import creatorValidation from './creatorValidation';
import managingPersonValidation from './managingPersonValidation';

const validationFunctions = {
  title: titleValidation,
  description: descriptionValidation,
  published: publicityValidation,
  contentType: contentTypeValidation,
  creators: creatorValidation,
  persons: managingPersonValidation,
  facultyDepartment: facultyDepartmentValidation,
  science: scienceValidation
};

const useCollectionValidation = (fields) => {
  const [isValid, messages, validate] = useValidation(
    [validationFunctions], 
    fields
  );

  return [
    isValid[0], 
    messages[0], 
    (collection, previousCollection, validateAllFields) => 
      validate([collection], [previousCollection], validateAllFields)
  ];
};

export default useCollectionValidation;
